import { createContext } from "react";
import { MenuContextState } from "@component/core/Context/Menu/typeDefs";
export const initState: MenuContextState = {
  open: false
};
export const MenuContext = createContext({
  menu: initState,
  setMenu: (diff: Partial<MenuContextState>) => {}
});
export default MenuContext;